// local
// components
import { NavbarComponent } from 'src/app/core/components/navbar/navbar.component';
import { SideNavComponent } from 'src/app/core/components/side-nav/side-nav.component';
// services
import {
    HttpInterceptorService
} from 'src/app/core/services/http-interceptor/http-interceptor.service';
import { HttpLoadingService } from 'src/app/core/services/http-loading/http-loading.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';

// third party
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import {
    MatProgressBarModule
} from '@angular/material/progress-bar';
import {
    MatProgressSpinnerModule
} from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MsalBroadcastService, MsalModule, MsalService } from '@azure/msal-angular';
import {
    ApplicationinsightsAngularpluginErrorService
} from '@microsoft/applicationinsights-angularplugin-js';

import { SideBarComponent } from '../side-bar/side-bar.component';
import { InsightsService } from './services/insights/insights.service';
import { SideBarService } from './services/side-bar/side-bar.service';

@NgModule({ declarations: [
        NavbarComponent,
        SideNavComponent,
    ],
    exports: [
        NavbarComponent,
        SideNavComponent,
    ], imports: [
        // ANGULAR
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        // MATERIAL
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTooltipModule,
        // AUTH
        MsalModule,
        SideBarComponent], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
        InsightsService,
        {
            provide: ErrorHandler,
            useClass: ApplicationinsightsAngularpluginErrorService,
        },
        HttpLoadingService,
        MsalService,
        MsalBroadcastService,
        ProfileService,
        SideBarService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }
